import React from "react";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import DatePicker from "../../../../../../components/form/DateTime";
import Input from "../../../../../../components/form/Input";
import CroField from "../../../generalForm/CroField";
import CroPriceField from "../../../generalForm/CroPriceField";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import { fieldsRemove } from "../../../../CroUtils";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import {
  importNumWithComma,
  exportNumWithDot,
  notForPublic,
} from "../../../../CroUtils";
import { FormattedMuiInput } from "../../../../../../components/form/Input";
import { ItemNumber, useItemHandlers } from "./itemRenumber";

export default ({
  fields,
  disabled,
  noPublicLogged,
  dos,
  ongoing,
  wps,
  t,
  point3,
  auth,
  isPublicStatement,
  outgoing,
  versionChangedClass
}) => {
  const { addItem, removeItem } = useItemHandlers(fields);
  return (
    <div className="cro-array-container">
      {fields.map((item, index) => (
        <div key={index} className={`cro-array-item ${versionChangedClass ? versionChangedClass(item) : ""}`}>
          <ItemNumber index={index} />
          {!disabled && fields.length > 1 && (
              <CroRemoveButton onClick={() => removeItem(index)} />
          )}
          <div className="cro-array-item-content">
            <div className="statementForm__arrayGrid">
              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.commercialPaperType`) : ""}
                title="Druh"
                name={`${item}.commercialPaperType`}
                component={AutoComplete}
                disabled={disabled}
                url="/api/ciselniky/cenny-papiry"
                validate={[V.required, V.isDictionary]}
                helpEnum={H[`${t}CP_TYPE`].r}
              />

              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.issuer`) : ""}
                title="Emitent"
                name={`${item}.issuer`}
                component={Input}
                disabled={disabled}
                validate={[V.required]}
                helpEnum={H[`${t}CP_ISSUER`].r}
              />

              {notForPublic(isPublicStatement, auth) &&
                (ongoing || outgoing) && (
                  <CroPriceField
                    className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                    title="Pořizovací­ cena"
                    name={`${item}.price`}
                    component={Input}
                    disabled={disabled}
                    validate={[V.isNumeric]}
                    helpEnum={H[`${t}CP_PRICE`].r}
                  />
                )}

              {!dos && !point3 && wps > 1 && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.acquisitionDate`) : ""}
                  title="Datum nabytí"
                  name={`${item}.acquisitionDate`}
                  component={DatePicker}
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}

              {!dos && notForPublic(isPublicStatement, auth) && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.amount`) : ""}
                  title="Počet"
                  name={`${item}.amount`}
                  disabled={disabled}
                  validate={[V.isNumeric]}
                  normalize={exportNumWithDot}
                  format={importNumWithComma}
                  component={FormattedMuiInput}
                  thousandSeparator={" "}
                  isNumericString={true}
                  decimalSeparator={","}
                />
              )}
              {(!dos || (dos && (outgoing || ongoing))) &&
                notForPublic(isPublicStatement, auth) && (
                  <div className="statementForm__arrayFull">
                    <CroField
                      className={versionChangedClass ? versionChangedClass(`${item}.ownership`) : ""}
                      title="Vlastnictví"
                      name={`${item}.ownership`}
                      component={AutoComplete}
                      disabled={disabled}
                      fullWidth
                      url="/api/ciselniky/zpusob-vlastnictvi"
                      validate={[V.isDictionary]}
                    />
                  </div>
                )}

              {noPublicLogged && (
                <div className="statementForm__arrayFull">
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                    title="Poznámka"
                    name={`${item}.note`}
                    component={Input}
                    disabled={disabled}
                    multiline
                    helpEnum={H[`${t}CP_NOTE`].r}
                    maxlen={1000}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {!disabled && (
        <div className="cro-array-add">
          <CroAddButton onClick={() => addItem()} />
          <Help helpEnum={H.ADD_REMOVE_CP.r} />
        </div>
      )}
    </div>
  );
};
